import { useContext, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { ToastContext } from "../Components/ToastProvider";

import LoadingButton from "../Components/LoadingButton";

function ResetPassword() {
  const { id, token } = useParams();
  const navigate = useNavigate();

  const { error, resetPassword } = useAuth();
  const { createToast } = useContext(ToastContext);

  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handleResetPassword = (event) => {
    event.preventDefault();

    if (password !== passwordConfirm) {
      createToast("The two passwords don't match.", "error");
      return;
    }
    setDisabled(true);

    resetPassword(password, passwordConfirm, id, token).then(
      async (success) => {
        if (success) {
          createToast(
            "You successfully changed your password, now let's take you to the Login page",
            "success",
            true
          );
          navigate("/login");
        } else {
          createToast("Something went wrong. Please try again", "error");
          setDisabled(false);
        }
      }
    );
  };

  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      <h1>Reset Password</h1>
      <form id="reset-password-form" onSubmit={handleResetPassword}>
        <label htmlFor="password">Your New Password</label>
        <p className="remark">
          Must contain at least one number and one uppercase and lowercase
          letter, and at least 8 or more characters
        </p>
        <input
          id="password"
          type="password"
          value={password}
          minLength="8"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          onChange={(event) => {
            setPassword(event.target.value);
          }}
        ></input>
        <label htmlFor="password2">Confirm Your New Password</label>
        <input
          id="password2"
          type="password"
          value={passwordConfirm}
          minLength="8"
          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
          onChange={(event) => {
            setPasswordConfirm(event.target.value);
          }}
        ></input>
        <LoadingButton
          type="submit"
          disabled={disabled}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <p className="margin-t-40 underline">
          <Link to="/login">Login</Link>
        </p>
        <p className="underline">
          <Link to="/register">Register</Link>
        </p>
      </form>
    </div>
  );
}

export default ResetPassword;
